module.exports = __webpack_public_path__ + "static/media/announcement-description.c5fb7a10.svg";